import {Vue} from 'ui.vue';

import './BXmakerAuthuserphoneCheckbox.styl';

import './BXmakerAuthuserphoneButton';


/**
 * @emits onChange {name:string, value:boolean} (local) -  ��� ��������� �����
 */
Vue.component('BXmakerAuthuserphoneCheckbox',
    {
        props: {
            name: { // �������� ����
                type: [String],
                default: "not_set"
            },
            checked: { // ���� ��� ������� ����
                type: Boolean,
                default: false,
            },
            label:{
                type: [String],
                default: ""
            }
        },
        methods: {
            onChange(e) {
                this.$emit('onChange', {
                    name:this.name,
                    value: e.target.checked
                })
            },
        },
        template: `
            <div class="bxmaker-authuserphone-checkbox">
                <label class="bxmaker-authuserphone-checkbox-button">
                    <input type="checkbox" value="Y" :name="name" :checked="checked" @change="onChange"  />
                    <span>{{label}}</span>
                </label>
            </div>
        `,
    });